import { ChangeEvent, useRef, useState } from "react";
import { venueService } from "services/venueService";
import { convertHoursToDays } from "utils/convertHoursToDisplayString";
import moment from "moment";
import { errorAlert, successAlert } from "utils/alertHandler";
import { useTranslation } from "react-i18next";
import { store } from "store";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

export default function useProfileBookingCard({ data, credentials, minHourBeforeCancel }: any) {
  const { venue_booking_id, start_date_time, end_date_time, payment_proof_url, status } = data;

  const inputRef = useRef<any>();

  const start = moment(start_date_time);
  const end = moment(end_date_time);
  const current = moment();

  const getFormattedCredentials = () => {
    if (current.isAfter(end)) {
      return {
        enableDisplay: false,
        message: "",
      };
    }

    if ((current.isBefore(start) && Math.abs(moment.duration(start.diff(current)).asHours()) <= credentials?.timer_display_password) || (current.isBefore(end) && current.isAfter(start))) {
      return {
        enableDisplay: true,
        icon: "la-key",
        message: `密碼 : ${credentials?.password}`,
      };
    }

    if (current.isBefore(start) && Math.abs(moment.duration(start.diff(current)).asHours()) > credentials?.timer_display_password) {
      return {
        enableDisplay: true,
        icon: "la-lock",
        message: `密碼將約開始前 ${credentials?.timer_display_password * 60} 分鐘顯示`,
      };
    }
  };

  const formatted_credentials = getFormattedCredentials();

  const [isUploadingPayment, setIsUploadingPayment] = useState<boolean>(false);
  const [isPaymentCompleted, setIsPaymentCompleted] = useState<boolean>(payment_proof_url != null);

  const isBookingExpired = start.isSameOrBefore(current);
  const totalHours = convertHoursToDays(moment.duration(end.diff(start)).asHours());

  const isEnableCancel = status !== 0 && start.isAfter(current) && Math.abs(moment.duration(start.diff(current)).asHours()) >= minHourBeforeCancel;

  const { t } = useTranslation();

  const _onPaymentUpload = async (e: ChangeEvent<HTMLInputElement>) => {
    try {
      if (!e.target.files) return;

      const user_id = store.getState()!["auth"]["user"]!["user_id"];

      setIsUploadingPayment(true);

      const result = await venueService.uploadVenueBookingPaymentReceipt(
        {
          venue_booking_id: venue_booking_id,
          venue_id: Number(REACT_APP_DEFAULT_VENUE_ID),
          user_id: Number(user_id),
        },
        e.target.files[0]
      );

      setIsUploadingPayment(false);

      if (!result) return;

      successAlert(t("profile_upload_receipt_success"));

      setIsPaymentCompleted(true);
    } catch (error: any) {
      successAlert(t("profile_upload_receipt_fail"));
      setIsUploadingPayment(false);
    }
  };

  return { inputRef, start, end, formatted_credentials, isBookingExpired, totalHours, isEnableCancel, isUploadingPayment, isPaymentCompleted, _onPaymentUpload };
}
